<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col s12">
          <h2>{{ pageName }}</h2>
        </div>
      </div>

      <div class="row">
        <div class="col s12">
          <timeline :timeline="timeline"></timeline>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as QuaeseData from "../_data/";
import Timeline from "../../../app/components/timeline.component";

export default {
  name: "moreinfo",

  components: {
    timeline: Timeline
  },

  data() {
    return {
      css: {
        cardLight: "grey lighten-5",
        cardLightColored: "blue-grey lighten-5"
      },
      pageName: "Timeline",

      timeline: QuaeseData.timeline
    };
  }
};
</script>

<style lang="less" scoped></style>
